import React from 'react';

const CaracteristicasCards = ({ caracteristicas, onToggle, onBack, t }) => (
  <div>
    <button
      onClick={onBack}
      className="flex items-center gap-2 text-sm text-white bg-[#34568B] hover:bg-[#2c4775] px-4 py-2 rounded-full shadow transition mb-6 mt-5"
    >
      ← {t('labels.back_to_ambitos', 'Volver a ámbitos')}
    </button>
    <div className="space-y-3">
      {caracteristicas.map(c => {
        const necesitaAyuda = c.estado === "necesita ayuda";
        return (
          <div
            key={c.id}
            className="flex items-center justify-between p-3 rounded-lg bg-white border hover:shadow-md"
          >
            <span className="text-gray-800 text-sm w-2/3">
              {t(`labels.${c.descripcion}`, c.descripcion)}
            </span>

            <div className="flex items-center gap-3">
              <span
                className={`text-xs font-medium ${
                  necesitaAyuda ? "text-green-600" : "text-gray-400"
                }`}
              >
                {necesitaAyuda
                  ? `🟢 ${t("state.needs_help", "Necesita ayuda")}`
                  : `⚪ ${t("state.no_help", "No necesita ayuda")}`}
              </span>

              <div
                className={`relative inline-block w-12 h-6 ${
                  necesitaAyuda ? "bg-green-400" : "bg-gray-300"
                } rounded-full cursor-pointer`}
                onClick={() => onToggle(c.id)}
              >
                <span
                  className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow transform duration-200 ease-in-out ${
                    necesitaAyuda ? "translate-x-6" : "translate-x-0"
                  }`}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default CaracteristicasCards;
